import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { firstValueFrom, take } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { StorageService, LanguageService, RouterService } from '@venecia/services';
import { GlobalConstants } from '@venecia/constants';
import { } from './language.service';

@Injectable({ providedIn: 'root' })
export class I18nService {

    private readonly t = inject(TranslateService);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly routerService = inject(RouterService);
    private readonly storageService = inject(StorageService);
    private readonly languageService = inject(LanguageService);

    constructor() { }

    async initialize(): Promise<void> {
        const langFromQueryParam = this.activatedRoute.snapshot.queryParams[GlobalConstants.LANG_KEY];

        this.t.addLangs(this.languageService.getSupportedCodeLanguage());

        const newLang = this.languageService.isSupportedLanguage(langFromQueryParam)
            ? langFromQueryParam!
            : this.languageService.getCurrentOrDefault();

        if (this.t.getCurrentLang() !== newLang) {
            if (newLang === "en") {
                this.t.resetLang(newLang);
            }

            await firstValueFrom(this.t.use(newLang));
            this.languageService.setCurrent(newLang);
        }

        this.routerService.setQueryParams({
            [GlobalConstants.LANG_KEY]: newLang,
        });
    }

    changeLanguage(langCode: string): void {
        if (this.languageService.isSupportedLanguage(langCode)) {
            const newLang = langCode.toLocaleLowerCase();

            if (newLang === "en") {
                this.t.resetLang(newLang);
            }

            this.storageService.set<string>(GlobalConstants.LANG_KEY, newLang);
            this.t.use(newLang)
                .pipe(take(1))
                .subscribe(() => {
                    this.routerService.setQueryParams({
                        [GlobalConstants.LANG_KEY]: newLang,
                    });
                });
        }
    }
}